import React from 'react'
import FormInput from '../../../library/form/components/FormInput';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormCheckbox from '../../../library/form/components/FormCheckbox'
import * as fn from "../../../helper/uiFunctions";

const InvCostBreakupRow = (props) => {
    const { formObject, viewData, rowKey } = props;

    if (fn.compareNumber(viewData.dataList.isEditMode, 1)) {
        return (
            <ul className="uiDPEditLine">
                <li className="uiColumnCenter " style={{width:"185px"}}>
                    <FormInput formObject={formObject} rowKey={rowKey}
                        action={{ InputType: "ac", paramName: "cstType", acMethod: "CategoryDetail", acDepCtrl: { dparam: '1' } }}
                        className="uiAutoCompleteInput"  ></FormInput>
                </li>
                <li className="uiColumnCenter uiColumn100">
                    <FormInput formObject={formObject} rowKey={rowKey} style={{ width: "98%" }}
                        action={{ InputType: "input", paramName: "cost", actionid: "refresh", actionparam: { updatebreakuptotal: 1 } }}
                    />
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormCheckbox formObject={formObject} rowKey={rowKey} 
                        action={{ paramName: "isCharged" }}
                        id="cbcostpayeevalue" /> 
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormCheckbox formObject={formObject} rowKey={rowKey} 
                        action={{ paramName: "isPayee" }}
                        id="cbcostpayeevalue" />
                </li>
                <li className="uiColumnCenter " style={{width:"185px"}}>
                    <FormInput formObject={formObject} rowKey={rowKey}
                        action={{ InputType: "input", paramName: "costCmnt" }}
                    />
                </li>
                <li className="uiColumnCenter uiColumn100 uiActionBlock">
                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="confirm"
                        onlyIcon={true}
                        tooltip="Confirm Changes"
                        starIconClassName="uiColorNeutralAction"
                        action={{ actionId: "save",  actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>

                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="cancel"
                        onlyIcon={true}
                        tooltip="Cancel Changes"
                        starIconClassName="uiColorNegativeAction"
                        action={{ actionId: "cancel",  actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>
                </li>
            </ul>
        )
    }
    else {
        return (
            <ul >
                <li className="uiColumnCenter" style={{width:"185px"}}>
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "cstType" }} />
                </li>
                <li className="uiColumnCenter uiColumn100">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "cost" }} />
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "isCharged" }} />
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "isPayee" }} />
                </li>
                <li className="uiColumnCenter" style={{width:"185px"}}>
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "costCmnt" }} />
                </li>
                <li className="uiColumnCenter uiColumn100 uiActionBlock" >
                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="edit"
                        onlyIcon={true}
                        tooltip="Edit"
                        starIconClassName="uiColorNeutralAction"
                        action={{ actionId: "edit",  actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>

                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="clear"
                        onlyIcon={true}
                        tooltip="Delete"
                        starIconClassName="uiColorNegativeAction"
                        action={{ actionId: "del",  actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>
                </li>
            </ul>
        )
    }
}

export default InvCostBreakupRow